module.exports = __webpack_public_path__ + "media/images/flags/et-fd66504709c1d95041b5aaf51bd0995b.svg";